export const FETCH_ORDERS_REQUEST = "FETCH_ORDERS_REQUEST";
export const FETCH_ORDERS_SUCCESS = "FETCH_ORDERS_SUCCESS";
export const FETCH_ORDERS_FAILURE = "FETCH_ORDERS_FAILURE";

export const fetchOrdersRequest = (page) => ({
  type: FETCH_ORDERS_REQUEST,
  payload: { page },
});

export const fetchOrdersSuccess = (orders, totalPages) => ({
  type: FETCH_ORDERS_SUCCESS,
  payload: { orders, totalPages },
});

export const fetchOrdersFailure = (error) => ({
  type: FETCH_ORDERS_FAILURE,
  payload: { error },
});